module.exports = __webpack_public_path__ + "static/img/12.cbc04df.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/eng/12.png
// module id = 4j4a
// module chunks = 0